import React from 'react';
import styled, { css } from 'styled-components';
import { Container, Column, Flex } from '../design-system';
import BlockLink from './BlockLink';
import Logo from './Logo';

export const MainContainer = styled(Container)(
  ({ theme }) => css`
    background-color: ${theme.colors.greyLightest};
    padding: 0;
  `,
);

export const FormContainer = styled(Flex)(
  () => css`
    min-width: 300px;
    form {
      width: 100%;
    }
  `,
);

export const StyledBlockLink = styled(BlockLink)(
  ({ theme }) => css`
    color: ${theme.colors.blue};
  `,
);

export const SuccessfulSubmission = styled(Flex)(
  ({ theme }) => css`
    color: ${theme.colors.green};
  `,
);

const BrandWrapper = styled(Column)(
  ({ theme }) => css`
    background-color: ${theme.colors.greyDark};
  `,
);

const GrantHolsterBrand = () => (
  <BrandWrapper width="50%" justifyContent="center" alignItems="center">
    <Logo width="30rem" />
  </BrandWrapper>
);

export default GrantHolsterBrand;
